'use strict';

import platform from 'platform';

import api      from './api';
import store    from './store';

export default ({router}) => {
  document.addEventListener('deviceready', () => {
    if (store.getters.isLoggedIn && typeof(window.PushNotification) !== 'undefined') {
      let push = window.PushNotification.init({
        android: {
          senderID: "712053586007",
          icon: 'notification',
          iconColor: '#1e3f67',
          clearBadge: true,
          clearNotifications: true,
          forceShow: true
        },
        ios: {
          alert: true,
          badge: true,
          sound: true,
          clearBadge: true
        }
      });
      push.on('registration', data => {
        if (data.registrationId) {
          const idHash = {};
          if (platform.os.toString().toLowerCase().match(/^ios/)) {
            idHash.ios_push_id = data.registrationId;
          } else if (platform.os.toString().toLowerCase().match(/android/)) {
            idHash.android_push_id = data.registrationId;
          }
          // Only update push id if it changes
          if (idHash.ios_push_id !== store.getters.currentUser.ios_push_id || idHash.android_push_id !== store.getters.currentUser.android_push_id) {
            api.User.update({params: {id: store.getters.currentUser.id, user: idHash}})
              .then(user => {
                store.commit('logIn', user);
              });
          }
        }
      });
      push.on('notification', data => {
        if (data.additionalData && data.additionalData.path) {
          router.push(data.additionalData.path);
        }
      });
    }
  });
};
